module.exports = __webpack_public_path__ + "static/img/neterror@2x.c3e48bde.png";